import Recovery from './Recovery';

export default Recovery;
